import React from "react";
import "./Signup.css";
import FadeIn from "react-fade-in";
import { BlacklistModal } from "./BlacklistModal";

export class SignupCodeCheck extends React.Component {
  _mounted = false;
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      code: "",
      emailRegex:
        "[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?",
      emailSent: false,
      submitEnabled: false,
      countdown: 20,
      tries: 0,
      locked: false,
      showBlackListedModal: false,
      blackListData: {},

      devCode: "DEV123"
    };

    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleCodeChange = this.handleCodeChange.bind(this);
    this.handleEmailButton = this.handleEmailButton.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.callCodeEmail = this.callCodeEmail.bind(this);
    this.showBlackListedModal = this.showBlackListedModal.bind(this);

    this.closeBlackListedModal = this.closeBlackListedModal.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }
  componentWillUnmount() {
    this._mounted = false;
    clearInterval(this.interval);
  }

  handleEmailChange(e) {
    let mail = e.target.value.replace(" ", "");
    this.setState({ email: mail });
  }

  handleEmailButton(e) {
    if (this.validateEmail(this.state.email) === false) {
      alert("Epost er ikke riktig utfyllt.");
    } else {
      this.callCodeEmail(e.target.value);
    }
  }

  /*
  handleCodeChange(e){
    this.setState({code: e.target.value});
    console.log(this.state.code.length);
    if(this.state.code.length === 7){
      this.setState({submitEnabled: true});
    }
    else{
      this.setState({submitEnabled: false});
    }
  }
  */

  handleCodeChange(e) {
    let code = e.target.value.toUpperCase();
    code = code.replace(" ", "");
    this.forceUpdate();
    this.setState({ code: code });

    // Check for dev code first (only in development mode)
    if (process.env.NODE_ENV === 'development' && code === this.state.devCode) {
      console.log('Dev code accepted!');
      const email = this.state.email || 'dev@example.com';

      // Use the same checkCode API - backend will handle dev mode
      fetch("/api/guidController/checkCode/DEV123/" + email, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      })
        .then(response => {
          if (response.ok) {
            return response.text();
          } else {
            throw new Error('Dev code validation failed');
          }
        })
        .then(guid => {
          console.log('Dev mode GUID:', guid);
          this.props.setSignupCodeStatus(guid);
          this.props.setP1Email(email);
        })
        .catch(error => {
          console.error('Error with dev GUID:', error);
          alert('Failed to process dev code. Please try again.');
        });
      return;
    }

    if (code.length === 6) {
      if (this._mounted === true) {
        //WE recieve GUID in return for our code
        fetch(
          "/api/guidController/checkCode/" + code + "/" + this.state.email,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json"
            }
          }
        )
          .then(response => {
            if (response.ok) {
              return response.text();
            } else {
              return Promise.reject("something went wrong!");
            }
          })
          .then(data => {
            this.props.setSignupCodeStatus(data);
          })
          .catch(error => console.log("Could not verify code"));
      }
    }
  }

  //We call the codemail api to send the code to the email. The function also gets the GUID as response
  callCodeEmail(e) {
    let mail = this.state.email.replace(" ", "");
    if (this._mounted === true) {
      fetch("/api/signupemailer/codeMail/" + mail, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          pragma: "no-cache",
          "cache-control": "no-cache"
        }
      })
        .then(response => {
          try {
            if (response.status === 401) {
              //blacklisted
              this.setState({ locked: true });
              this.getBlackListedInfo(mail);
            } else if (response.status !== 403) {
              this.setState({ locked: false });
              return response.json();
            } else {
              this.setState({ locked: true });
            }
          } catch (err) {
            this.setState({ locked: true });
          }
        })
        .then(responseJson => {
          if (this.state.locked === false) {
            this.setState({ guid: responseJson.guid });
            this.setState({ emailSent: true });
            if (this.state.countdown === 0) {
              clearInterval(this.interval);
            }
            this.setState({ countdown: 20 });
            this.setState({ tries: this.state.tries + 1 });
            this.props.setP1Email(this.state.email);
          }
          this.interval = setInterval(() => {
            if (this.state.countdown > 0) {
              this.setState({ countdown: this.state.countdown - 1 });
            } else {
              clearInterval(this.interval);
            }
          }, 1000);
        });
    }
  }

  validateEmail(email) {
    let re = new RegExp(this.state.emailRegex);
    if (!re.test(email)) {
      return false;
    }
    if (isNaN(email.substr(0, email.indexOf("@"))) === false) {
      return false;
    } else {
      return true;
    }
  }

  getBlackListedInfo(mail) {
    if (this._mounted === true) {
      fetch("/api/signupemailer/getBlacklistData/" + mail, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          pragma: "no-cache",
          "cache-control": "no-cache"
        }
      })
        .then(response => {
          return response.json();
        })
        .then(blackListData => {
          console.log(blackListData);
          this.setState({ blackListData: blackListData });
          this.forceUpdate();
          if (blackListData.length !== 0) {
            this.showBlackListedModal();
          }
        });
    }
  }

  showBlackListedModal() {
    this.setState({ locked: true });

    this.setState({ showBlackListedModal: true });
  }

  closeBlackListedModal() {
    window.location.reload();
  }

  render() {
    return (
      <FadeIn>
        {this.state.showBlackListedModal === true && (
          <BlacklistModal
            closeBlackListedModal={this.closeBlackListedModal}
            data={this.state.blackListData}
          />
        )}
        {this.state.showBlackListedModal !== true && (
          <div className="col summaryCard Signup CodeCheck">
            <p>
              Merk at the kan ta inntil 5 minutter før eposten dukker opp i din
              innboks!
            </p>
            <div>
              <input
                className="CodeInput"
                type="text"
                name="email"
                autoComplete="email"
                value={this.state.email}
                onChange={this.handleEmailChange}
                placeholder="Epost"
              />
              {this.state.emailSent === false && (
                <button
                  className="btn btno btn-success help CodeButton"
                  onClick={this.handleEmailButton}
                >
                  Send kode til epost
                </button>
              )}
              {this.state.emailSent === true &&
                this.state.countdown > 0 &&
                this.state.tries <= 15 && (
                  <button className="btn btn-info help CodeButton disabled">
                    {this.state.countdown}
                  </button>
                )}
              {this.state.tries >= 15 && (
                <h5>Du har blitt sperret i 15 minutter</h5>
              )}
              {this.state.locked && (
                <h5>Du må vente for å sende epost på nytt</h5>
              )}
              {this.state.emailSent === true && this.state.countdown === 0 && (
                <button
                  className="btn btno btn-info help CodeButton"
                  onClick={this.handleEmailButton}
                >
                  Send kode på nytt
                </button>
              )}
            </div>
            {this.state.tries > 3 && (
              <h5>Trenger du hjelp? Kontakt oss på Facebook</h5>
            )}

            <p> </p>

            <div>
              {(this.state.emailSent === true || process.env.NODE_ENV === 'development') && (
                <div>
                  <input
                    className="CodeInput"
                    type="text"
                    name="code"
                    onChange={this.handleCodeChange}
                    value={this.state.code}
                    placeholder="Kode"
                  />
                  <p>Husk å sjekke søppelpostmappen!</p>
                  {/* Dev mode code hint - only show in development */}
                  {process.env.NODE_ENV === 'development' && (
                    <div style={{
                      marginTop: '10px',
                      padding: '8px',
             
                      border: '1px solid #007acc',
                      borderRadius: '4px',
                      fontSize: '14px',
                      textAlign: 'center'
                    }}>
                      <strong>🚀 Dev Mode:</strong>
                      {this.state.emailSent ?
                        <span> Use code <code style={{
                          backgroundColor: '#e1ecf4',
                          padding: '2px 4px',
                          borderRadius: '3px',
                          fontWeight: 'bold'
                        }}>{this.state.devCode}</code> to bypass email verification</span>
                        :
                        <span> Enter <code style={{
                          backgroundColor: '#e1ecf4',
                          padding: '2px 4px',
                          borderRadius: '3px',
                          fontWeight: 'bold'
                        }}>{this.state.devCode}</code> to skip email step entirely</span>
                      }
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
      </FadeIn>
    );
  }
}

export default SignupCodeCheck;



// WEBPACK FOOTER //
// ./src/Components/Signup/SignupCodeCheck.js